import Fieldset from './fieldset'
import FieldsetTitle from './fieldset-title'
import FieldsetSubtitle from './fieldset-subtitle'
import FieldsetFooter from './fieldset-footer'
import FieldsetFooterStatus from './fieldset-footer-status'
import FieldsetFooterActions from './fieldset-footer-actions'
import FieldsetGroup from './fieldset-group'
import FieldsetContent from './fieldset-content'
import fieldsetLoader from './fieldset-loader'

FieldsetFooter.Status = FieldsetFooterStatus
FieldsetFooter.Actions = FieldsetFooterActions
Fieldset.Title = FieldsetTitle
Fieldset.Subtitle = FieldsetSubtitle
Fieldset.Footer = FieldsetFooter
Fieldset.Group = FieldsetGroup
Fieldset.Content = FieldsetContent
Fieldset.Body = FieldsetContent
Fieldset.Loader = fieldsetLoader

export default Fieldset
